module.exports = __webpack_public_path__ + "img/32.5.COD.f234746e.png";